import { render, staticRenderFns } from "./AMCAccountData.vue?vue&type=template&id=650c2860"
import script from "./AMCAccountData.vue?vue&type=script&lang=js"
export * from "./AMCAccountData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports